import React, { Component } from 'react';
import logo from '../logo.svg';
import Search from "./Search";
import Categories from "./Categories"
import Countries from "./Countries";
import Banner from "./Banner"
import '../App.css';

class Homepage extends Component {
    constructor(props) {
        super(props);

    }
    componentDidMount(){
        this.props.setnull();
        document.getElementById("root").scrollIntoView();

    }
    render() {
        return (
            <div className="App">
                <Search setSearchDefs={this.props.setSearchDefs} findImageBySlug={this.props.findImageBySlug} findSlug={this.props.findSlug} setSearch = {this.props.setSearch}/>
                {<Categories setSearchDefs={this.props.setSearchDefs} findImageBySlug={this.props.findImageBySlug} findGroup={this.props.findGroup} findSlug={this.props.findSlug} />}
                <Countries setSearchDefs={this.props.setSearchDefs} findImageBySlug={this.props.findImageBySlug} findGroup={this.props.findGroup} findSlug={this.props.findSlug} />
                {/*<Banner findImageBySlug={this.props.findImageBySlug} findSlug={this.props.findSlug} />*/}
            </div>
        );
    }
}

export default Homepage;
